import { useState } from "react";
import { LatLngLiteral } from "leaflet";

import { useSettingsDomain } from "./domainSettings";

export interface MapSettings extends LatLngLiteral {
  zoom: number;
}

const defaultMapSettings = {
  lat: 38.889931,
  lng: -77.009003,
  zoom: 10,
};

let latestMapSettings = defaultMapSettings;

export const useMapSettings = (): MapSettings => {
  const [mapSettings, setMapSettings] = useState(latestMapSettings);

  const { data } = useSettingsDomain({
    shouldRetryOnError: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    suspense: latestMapSettings === defaultMapSettings,
  });

  if (data) {
    const lat = data.data.map.start_y;
    const lng = data.data.map.start_x;
    const zoom = data.data.map.zoom_factor;

    const hasLocation = !Number.isNaN(lat) && !Number.isNaN(lng);

    if (
      hasLocation &&
      (lat !== mapSettings.lat ||
        lng !== mapSettings.lng ||
        zoom !== mapSettings.zoom)
    ) {
      const newMapSettings = {
        lat,
        lng,
        zoom,
      };

      latestMapSettings = newMapSettings;
      setMapSettings(newMapSettings);
    }
  }

  return mapSettings;
};
